import 'reflect-metadata';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from 'src/app/app.config';
import { App } from 'src/app/app';
import { datadogLogs } from '@datadog/browser-logs';

bootstrapApplication(App, appConfig)
  .catch((err) => datadogLogs.logger.error(err));
